export default __webpack_public_path__ + "static/media/apple-store-2x.00596724.png";